import React, { ReactElement, useState, useEffect } from 'react';
import className from 'classnames/bind';
import { connect } from 'react-redux';
import styles from './index.pcss';
import { showModal } from '../../../../actions/shared/modal';
import properties from '../../../../modules/ajio-util/properties';
import { calculateDifferenceFromToday } from '../../../utils/dateUtils';
import { fetchMarkAsHelpful } from '../../../../actions/ratings';
import { signInCheck } from '../../../../components/common/CheckUserStatus';
import { gtmEventPush, segmentEventPush } from '../../../../modules/ga/GTMdatalayer';
import { getRatingsColorConfig } from '../../../selectors/featureFlagsSelector';
import { replaceWithJioCDN } from '../../../../utils/imageHandling';

const cx = className.bind(styles);
const imgPath = `${properties.getProperty('assetUrl')}/static`;

const mapDispatchToProps = dispatch => {
  return {
    showModal: (name, config) => dispatch(showModal(name, config)),
    fetchMarkAsHelpful: (reviewId: string) => dispatch(fetchMarkAsHelpful({ reviewId }))
  };
};
const mapStateToProps = state => ({
  ratingsColor: getRatingsColorConfig(state?.flags)
});
const connector = connect(mapStateToProps, mapDispatchToProps);
const ReviewDetailsMobile = ({
  reviewData,
  fetchMarkAsHelpful,
  renderSinglePhotoModal,
  productDetails = {},
  isFleek = false,
  ratingsColor = {},
  ratingParityMsite = false
}: {}): ReactElement => {
  const {
    rating,
    reviewId,
    reviewText,
    reviewerName,
    isVerified,
    helpfulContent,
    createdDate,
    imageMap
  } = reviewData;
  const [heplfulCount, setHelpfulCount] = useState(helpfulContent);
  const [isMarkedAsHelpful, setIsMarkedAsHelpful] = useState(false);
  const postedDays = calculateDifferenceFromToday(Number(createdDate));
  const { productId, productName, productBrick } = productDetails;

  const triggerAPIForMarkAsHelpFull = async () => {
    const response = await fetchMarkAsHelpful(reviewId);
    setHelpfulCount(initial => initial + 1);
    setIsMarkedAsHelpful(true);
    gtmEventPush({
      event: 'reviews_rating_interactions',
      event_category: 'reviews_rating_interactions',
      event_action: 'Mark as helpful',
      event_label: reviewId,
      ...(productId.length > 0 && { product_id: productId }),
      ...(productName.length > 0 && { product_name: productName }),
      ...(productBrick.length > 0 && { product_brick: productBrick }),
      pageType: 'PDP',
      store_type: 'ajio'
    });
    
    // Segment Push Event
    segmentEventPush({
      event: 'Review Widget Interaction',
      event_category: 'reviews_rating_interactions',
      event_action: 'Mark as helpful',
      event_label: reviewId,
      products:[{
          ...(productId.length > 0 && { product_id: productId }),
          ...(productName.length > 0 && { product_name: productName }),
          ...(productBrick.length > 0 && { product_brick: productBrick }),
          product_brand: '',
          product_list_price: '',
          product_mrp: '',
          product_offer_price: '',
          product_rating: '',
          product_segment: '',
          product_vertical: '',
          screen_name: ''
      }],
      // pageType: 'PDP',
      store_type: 'ajio'
    });
  };

  useEffect(() => {
    const isSignedIn = signInCheck();
    const reviewToSetMarkAsHelpful = localStorage.getItem('setMarkAsHelpful');
    if (reviewToSetMarkAsHelpful && reviewToSetMarkAsHelpful == reviewId && isSignedIn) {
      triggerAPIForMarkAsHelpFull();
      localStorage.removeItem('setMarkAsHelpful');
    }
  }, [reviewId]);

  const handleMarkAsHelpfulClick = async () => {
    const isSignedIn = signInCheck();
    if (isSignedIn) {
      triggerAPIForMarkAsHelpFull();
    } else {
      localStorage.setItem('setMarkAsHelpful', reviewId);
      window.location.href = `/login?referrer=${window.location.pathname}`;
    }
  };

  const handleImageClick = i => {
    renderSinglePhotoModal(reviewData, i);
    gtmEventPush({
      event: 'reviews_rating_interactions',
      event_category: 'reviews_rating_interactions',
      event_action: 'review photos - viewed',
      event_label: reviewId,
      ...(productId.length > 0 && { product_id: productId }),
      ...(productName.length > 0 && { product_name: productName }),
      ...(productBrick.length > 0 && { product_brick: productBrick }),
      pageType: 'PDP',
      store_type: 'ajio'
    });
    // Segment Push event
    segmentEventPush({
      event: 'Review Widget Interaction',
      event_category: 'reviews_rating_interactions',
      event_action: 'review photos - viewed',
      event_label: reviewId,
      products:[{
          ...(productId.length > 0 && { product_id: productId }),
          ...(productName.length > 0 && { product_name: productName }),
          ...(productBrick.length > 0 && { product_brick: productBrick }),
          product_brand: '',
          product_list_price: '',
          product_mrp: '',
          product_offer_price: '',
          product_rating: '',
          product_segment: '',
          product_vertical: '',
          screen_name: ''
      }],
      // pageType: 'PDP',
      store_type: 'ajio'
    });
    
  };

  const {
    thresholdValue = 3,
    ratingBelowThresholdColor = '',
    ratingAboveThresholdColor = ''
  } = ratingsColor;

  const reviewDetailRatingBox = () => {
    if(ratingParityMsite){
      return (
        <div
          className={cx(
            'reviews-details-ratings-box-black'
          )}
          style={{
            border: '0.75px solid #202020'
          }}
        >
          <span
            className={cx(
              'reviews-details-rating-number-black',
              isFleek ? 'reviews-details-rating-fleek-number' : ''
            )}
          >
            <strong aria-label={`Rated ${rating} ${rating < 2 ? 'star': 'stars'}`}>{rating}</strong>
          </span>
          <img
            className={cx('reviews-details-rating-img')}
            src={`${imgPath}${'/img/fleek-rating-black-star.svg'}`}
            alt="Star icon"
            aria-hidden={true}
          />
        </div>
      )
    }else{
      return(
        <div
          className={cx(
            'reviews-details-ratings-box',
            rating < 3 ? 'reviews-details-ratings-box-red' : 'reviews-details-ratings-box-green'
          )}
          style={{
            backgroundColor: rating < thresholdValue ? ratingBelowThresholdColor : ratingAboveThresholdColor
          }}
        >
          <span
            className={cx(
              'reviews-details-rating-number',
              isFleek ? 'reviews-details-rating-fleek-number' : ''
            )}
          >
            <strong aria-label={`Rated ${rating} ${rating < 2 ? 'star': 'stars'}`}>{rating}</strong>
          </span>
          <img
            className={cx('reviews-details-rating-img')}
            src={`${imgPath}${
              isFleek ? '/img/fleek-rating-black-star.svg' : '/img/rating-star.svg'
            }`}
            alt="Star icon"
            aria-hidden={true}
            onError={e => (e.target.src = '/img/rating-star.svg')}
          />
      </div>
      )
    }
  }

  return (
    <>
      <div className={cx('reviews-details-container')}>
        <div className={cx('reviews-details-left')}>
          {reviewDetailRatingBox()}
        </div>
        <div className={cx('reviews-details-right')}>
          <div className={cx('reviews-details-text', isFleek ? 'reviews-details-text-fleek' : '')}>
            {reviewText}
          </div>
          {imageMap?.thumbnail?.length > 0 && (
            <div className={cx('reviews-details-images-container')} role="list" style={{display: 'flex'}}>
              {imageMap.thumbnail.map((el, i) => {
                const imgUrl = el.imageUrl || '';
                return (
                  <div role="listitem">
                  <div className={cx('reviews-details-images')} aria-haspopup="dialog" role="button" tabIndex={0} onClick={() => handleImageClick(i)}>
                    <img
                      className={cx('reviews-details-images-img')}
                      src={`${replaceWithJioCDN(imgUrl)}`}
                      alt="Customer product image"
                    />
                  </div>
                  </div>
                );
              })}
            </div>
          )}
          <div className={cx('reviews-details-customer')}>
            <div
              className={cx(
                'reviews-details-customer-name',
                isFleek ? 'reviews-details-text-fleek' : ''
              )}
            >
              <strong>{reviewerName}</strong>
            </div>
            {isVerified && (
              <>
                <div className={cx('reviews-details-divider')} aria-hidden={true}> | </div>
                <img
                  className={cx('reviews-details-review-verified-img')}
                  src={`${imgPath}${
                    isFleek ? '/img/confirm-fleek.svg' : '/img/review-verified.svg'
                  }`}
                  aria-hidden={true}
                  alt="Tick icon"
                  onError={e => (e.target.src = '/img/review-verified.svg')}
                />
                <div
                  className={cx(
                    'reviews-details-customer-verified',
                    isFleek ? 'reviews-details-customer-verified-fleek' : ''
                  )}
                >
                  Verified Purchase
                </div>
              </>
            )}
          </div>
          <span
            className={cx('reviews-details-posted', isFleek ? 'reviews-details-posted-fleek' : '')}
          >
            {postedDays}
          </span>
          <div className={cx('reviews-details-footer')}>
            <div
              className={cx(
                'reviews-details-helpful-text',
                isFleek ? 'reviews-details-text-fleek' : ''
              )}
            >
              <b>{heplfulCount}</b>
              <span
                className={cx(
                  'reviews-details-helpful-text2',
                  isFleek ? 'reviews-details-helpful-fleek-text2' : ''
                )}
              >
                People found this helpful
              </span>
            </div>
            {!isMarkedAsHelpful ? (
              <div
                className={cx(
                  'reviews-details-helpful-container',
                  isFleek ? 'reviews-details-helpful-fleek-container' : ''
                )}
                role={'button'}
                tabIndex={0}
                onClick={handleMarkAsHelpfulClick}
              >
                <img
                  className={cx('reviews-details-hand-img')}
                  src={`${imgPath}${isFleek ? '/img/Like-fleek.svg' : '/img/hand_grey.svg'}`}
                  alt="Thumbs up unselected icon"
                  aria-hidden={true}
                  onError={e => (e.target.src = '/img/hand_grey.svg')}
                />
                <span
                  className={cx(
                    'reviews-details-helpful-buttontext',
                    isFleek ? 'reviews-details-helpful-fleek-buttontext' : ''
                  )}
                >
                  Mark as helpful
                </span>
              </div>
            ) : (
              <div className={cx('reviews-details-helpful-container2')}>
                <img
                  className={cx('reviews-details-hand-img')}
                  src={`${imgPath}/img/hand_green.svg`}
                  alt="Thumbs up selected icon"
                  aria-hidden={true}
                  onError={e => (e.target.src = '/img/hand_green.svg')}
                />
                <span className={cx('reviews-details-helpful-buttontext2')}>Marked as helpful</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default connector(ReviewDetailsMobile);
